export default "__VITE_ASSET__DqtzNTMB__"